<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-01 15:15:48
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="card" style="width: 2.54rem; height: 1.6rem">
    <div class="card-header">
      <div>招聘信息</div>
      <div class="more">更多</div>
    </div>
      <Tabs :animated="false">
        <TabPane label="内部招聘">
          <div class="info" v-for="(item,index) in 6" :key="index" >
            <div class="tips-333">关于颐海公司漯河工厂机修元岗位的招聘</div>
            <div>2024-01-01</div>
          </div>
        </TabPane>
        <TabPane label="外部招聘">标签二的内容</TabPane>
    </Tabs>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>
